import styles from "./FieldError.module.css";

/**
 * The house inline field-error line (DESIGN.md: inline field errors), shared
 * by every inquiry submission path. Renders nothing without a message so call
 * sites can pass their error map entries unconditionally.
 */
export function FieldError({
	message,
}: {
	message?: string;
}): React.JSX.Element | null {
	if (!message) return null;
	return (
		<p role="alert" className={styles.error}>
			{message}
		</p>
	);
}
